export default __webpack_public_path__ + "static/media/project-jobsapp.ea39da59.png";